// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CheckoutReviewAndSubmitState from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import { Draft } from "immer";

const initialState: CheckoutReviewAndSubmitState = {
    isPlacingOrder: false,
    isApplyingPromotion: false,
    isRemovingPromotion: false,
    isRemovingPromotions: false,
    isCheckingOutWithPayPay: false,
    isPreloadingData: false,
    requestedDeliveryDate: null,
    isPromotionAppliedSuccess: false,
    isPromotionRemovedSuccess: false,
    isPromotionsRemovedSuccess: false,
    paymetricIFrameIsSet: false,
    validateForm: () => true,
    // Store Custom Code
    isApplyingAllowance: false,
    isRemovingAllowance: false,
};

const reducer = {
    "Pages/CheckoutReviewAndSubmit/BeginApplyAllowance": (draft: Draft<CheckoutReviewAndSubmitState>) => {
        draft.isApplyingAllowance = true;
    },
    "Pages/CheckoutReviewAndSubmit/CompleteApplyAllowance": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: { errorMessage?: string },
    ) => {
        draft.isApplyingAllowance = false;
        draft.allowanceErrorMessage = action.errorMessage;
    },
    "Pages/CheckoutReviewAndSubmit/BeginRemoveAllowance": (draft: Draft<CheckoutReviewAndSubmitState>) => {
        draft.isRemovingAllowance = true;
    },
    "Pages/CheckoutReviewAndSubmit/CompleteRemoveAllowance": (
        draft: Draft<CheckoutReviewAndSubmitState>,
        action: { errorMessage?: string },
    ) => {
        draft.isRemovingAllowance = false;
        draft.removeAllowanceErrorMessage = action.errorMessage;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
